export enum GenderEnumeratorFrontend {
    MALE = 'male',
    FEMALE = 'female',
    OTHER = 'other'
}